import React from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export default function Profile() {
  const { user } = useAuth();
  const { t } = useLang();
  if (!user) return null;
  const initials = (user.name || user.email).slice(0, 2).toUpperCase();
  return (
    <DashboardLayout title={t("profile.title")} subtitle={t("profile.subtitle")}>
      <div className="max-w-2xl rounded-xl border border-zinc-800 bg-zinc-900/40 p-8" data-testid="profile-card">
        <div className="flex items-center gap-4">
          <Avatar className="h-16 w-16">
            <AvatarImage src={user.picture || undefined} />
            <AvatarFallback className="bg-zinc-800 text-zinc-100 text-lg">{initials}</AvatarFallback>
          </Avatar>
          <div>
            <div className="font-display text-xl font-semibold text-zinc-100">{user.name}</div>
            <div className="text-sm text-zinc-500">{user.email}</div>
            <div className="mt-1 overline text-indigo-400">{user.role}</div>
          </div>
        </div>
        <div className="mt-8 grid grid-cols-2 gap-6 text-sm">
          <div><div className="overline mb-1">Provider</div><div className="text-zinc-200">{user.provider}</div></div>
          <div><div className="overline mb-1">Tenant</div><div className="text-zinc-200">{user.tenant_id || "—"}</div></div>
          <div><div className="overline mb-1">Since</div><div className="text-zinc-200">{user.created_at?.slice(0, 10)}</div></div>
          <div><div className="overline mb-1">Status</div><div className="text-zinc-200">{user.active ? "Active" : "Disabled"}</div></div>
        </div>
      </div>
    </DashboardLayout>
  );
}
